import {BehaviorSubject} from 'rxjs';
import {Injectable} from '@angular/core';
import {filter} from 'rxjs/operators';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

@Injectable({providedIn: 'root'})
export class AppState {
    wideMode$ = new BehaviorSubject<boolean>(false);

    constructor(route: ActivatedRoute, router: Router) {
        router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                const {wideMode, extraWideMode, helpMode} = AppState.firstRoute(route).snapshot.data;
                this.wideMode$.next(wideMode);
            });
    }

    private static firstRoute = (route: ActivatedRoute): ActivatedRoute =>
        route.firstChild ? AppState.firstRoute(route.firstChild) : route;
}
